export const DEBUG = true;
const TAG_CSS = "color: #6969be; font-weight: bold";
const HEADER_CSS = "color: #555";

export function debug(context, message) {
  if (!DEBUG) return;
  // eslint-disable-next-line no-console
  console.debug(`%c[${context}] %c${message}`, TAG_CSS, HEADER_CSS);
}

export function loadAsyncScript(srcPath) {
  const scriptNode = document.createElement("script");

  scriptNode.async = 1;
  scriptNode.src = srcPath;

  const targetNode = document.querySelector("head") ?? document.body;

  targetNode.appendChild(scriptNode);
}

export function isTrackingEnabled() {
  return !window.navigator.userAgent.match(/Feather/);
}
